/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FinancialSupportCaseSelectionDto } from '../../models/financial-support-case-selection-dto';
import { FinancialSupportSelectionUpdateDto } from '../../models/financial-support-selection-update-dto';

export interface FinancialSupportCaseControllerSelect$Params {
  id: string;

/**
 * 분석 케이스 생성 시 발급한 비회원 세션 토큰
 */
  'X-Financial-Support-Token': string;
      body: FinancialSupportSelectionUpdateDto
}

export function financialSupportCaseControllerSelect(http: HttpClient, rootUrl: string, params: FinancialSupportCaseControllerSelect$Params, context?: HttpContext): Observable<StrictHttpResponse<FinancialSupportCaseSelectionDto>> {
  const rb = new RequestBuilder(rootUrl, financialSupportCaseControllerSelect.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-Financial-Support-Token', params['X-Financial-Support-Token'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FinancialSupportCaseSelectionDto>;
    })
  );
}

financialSupportCaseControllerSelect.PATH = '/api/financial-support/cases/{id}/selection';
